const apiUrls = {
    Admin: 'admins',
    AdminDelete: 'admins/{0}',
    AdminUpdate: 'admins/{0}',
    AdminPasswordUpdate: 'admins/{0}/password',
    User: 'users',
    UserUpdate: 'users/{0}',
    UserDelete: 'users/{0}',
    UserPasswordUpdate: 'users/{0}/password',
    UserAssignAdmin: 'users/{0}/assign_admin',
    UserUnassignAdmin: 'users/{0}/unassign_admin',
    UserGetAssignedAdmin: 'users/{0}/admin',
    BoostsRule: "boost/rules/aggregated",
    BoostCategories: 'boost/categories',
    BoostStatusActivateUpdate: 'boost/rules/aggregated/activate',
    BoostStatusInactivateUpdate: 'boost/rules/aggregated/inactivate',
    CrateBoostRule: 'admin/boosts/boost-rules',
    BoostAssignments: 'boost/assignments',
    BoostVariants: 'boost/variants',
    AssignBoostsRuleStatus: "boost/rules/{0}/coverage",
    BoostAssignmentsStatusUpdate: 'boost/assignments/{0}',
    BoostAssignmentsUsageToUser: 'boost/assignments/{0}/usage',
    BoostTickets: 'boost/tickets',
    BoostAssignmentsId: 'boost/assignments/{0}',
    TicketApprove: 'boost/tickets/{0}/approve',
    TicketReject: 'boost/tickets/{0}/reject',
    TicketComplete: 'boost/tickets/{0}/complete',
    BoostAssignmentsSpecialCancel: 'boost/assignments/{0}/cancel',
    TicketRead: 'boost/tickets/{0}/read',
};

export { apiUrls };
